<template>
  <div id="app" :class="appClass">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  computed: {
    appClass() {
      const pageName = this.$route.path.replace('/', '');
      this.classes = [];
      this.classes.push((pageName !== '') ? pageName : 'home');
      return this.classes.join(' ');
    },
  },
};
</script>

<style lang="scss">
  // @import url('https://fonts.googleapis.com/css?family=Lato:300,400,700');
  // @import url('https://pro.fontawesome.com/releases/v5.8.1/css/all.css');
  @import './assets/scss/saffron-v1';
  @import '~vue-wysiwyg/dist/vueWysiwyg.css';

  #app{
    &:not(.home){
      &:after{
        content: '';
        height: 200px;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        background: rgb(228,166,240);
        background: -moz-linear-gradient(0deg, rgba(228,166,240,1) 31%, rgba(255,249,229,1) 100%);
        background: -webkit-linear-gradient(0deg, rgba(228,166,240,1) 31%, rgba(255,249,229,1) 100%);
        background: linear-gradient(0deg, rgba(228,166,240,1) 31%, rgba(255,249,229,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#e4a6f0",endColorstr="#fff9e5",GradientType=1);
        z-index: -1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue